<!-- <app-breadcrumb [title]="'Login'" [breadcrumb]="'Login'"></app-breadcrumb> -->
<!-- section start -->
<section class="login-page section-b-space">
    <div class="container">
        <div class="row text center">
            <div class="col-lg-4 text-center">
            </div>
            <div class="col-lg-4 text-center">
                <img [src]="'assets/images/icon/logo-icon-antiga.png'" class="img-fluid" alt="collection-banner">
                <div class="theme-card">
                    <form class="theme-form">
                        <div class="form-group">
                            <label for="email">Email</label>
                            <input type="text" class="form-control" id="email" placeholder="Email" name="email" required="" [(ngModel)]="email">
                        </div>
                        <div class="form-group">
                            <label for="review">Senha</label>
                            <input type="password" class="form-control" id="senha" placeholder="Digite sua senha" name="senha" required="" [(ngModel)]="senha">
                        </div>
                        <a (click)="recuperarSenha()" href="javascript:void(0)" class="text-black ms-auto"><i class="fa fa-lock me-2"></i>Esqueci a senha</a>
                        <div class="form-group mt-3">
                            <a routerLink="/pages/register">Clique aqui para solicitar cadastro</a>
                        </div>                       
                        <button class="btn btn-solid mt-5" (click)="loginS()">Entrar</button>
                    </form>
                </div>
            </div>
            <div class="col-lg-4 text-center">
            </div>
            <!-- <div class="col-lg-6 right-login" hidden>
                <h3>Novo Cliente</h3>
                <div class="theme-card authentication-right">
                    <h6 class="title-font">Crie uma conta</h6>
                    <p>Crie uma conta gratuita em nossa loja. O registro é rápido e fácil. Permite-lhe encomendar na nossa loja. Para começar a comprar, clique em registrar.</p>
                    <button class="btn btn-solid">Registrar</button>
                </div>
            </div> -->
        </div>
    </div>
</section>
<footer>
	<section class="section-b-space light-layout">
		<div class="container">
			<div class="row footer-theme partition-f">
				<div class="col-lg-4 col-md-6">
					<div class="footer-title footer-mobile-title">
						<h4>about</h4>
					</div>
					<div class="footer-contant">
						<div class="footer-logo">
							<img [src]="themeLogo" alt="logo">
						</div>
						<div class="footer-social">
                            <ul>
                                <li>
                                    <a href="https://pt-br.facebook.com/tourregular/" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/confiancatur/" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                </li>
                            </ul>
                        </div>
					</div>
				</div>
				<div class="col">
					<div class="sub-title">
						<div class="footer-title">
						    <h4>Informações da Empresa</h4>
						</div>
						<div class="footer-contant">
						    <ul class="contact-list">
						        <li><i class="fa fa-map-marker"></i>Av. São Sebastião, 2852 - Quilombo, Cuiabá - MT, 78045-305</li>
						        <li><i class="fa fa-phone"></i>Telefone: (65) 3314-2700</li>
						        <li><i class="fa fa-envelope-o"></i>Email: <a style="text-transform: lowercase;">receptivo@confiancaturismo.com.br</a></li>
						    </ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<div class="sub-footer">
		<div class="container">
			<div class="row">
                <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="footer-end">
                    <p><i class="fa fa-copyright" aria-hidden="true"></i> Confiança Turismo</p>
                  </div>
                </div>
                <!-- <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="payment-card-bottom">
                    <ul>
                      <li>
                        <a><img src="assets/images/icon/visa.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/mastercard.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/paypal.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/american-express.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/discover.png" alt=""></a>
                      </li>
                    </ul>
                  </div>
                </div> -->
            </div>
		</div>
	</div>
</footer>
<!--Section ends-->

<ng-template #recuperarModal let-modal>
    <div class="modal-body">
        <div class="mb-3 row">
          <h3 class="text-center">Inserir email do usuário</h3>
          <input type="email" required="" placeholder="Email" [(ngModel)]="recuperar" />
        </div>
        <div class="col-12">
            <button class="btn d-block w-100 btn-lg btn-danger" type="submit" name="action"
                (click)="novaSenha()">Recuperar</button>
        </div>
    </div>
  </ng-template>